"use strict";
/**
 * VisiJson - flat boolean visibility toggles.
 * Stored in the visi_json column. All show_* keys default to true when absent.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VISI_FIELD_KEYS = void 0;
/** All field-level toggle keys for iteration */
exports.VISI_FIELD_KEYS = [
    'show_hometown', 'show_relocation', 'show_height', 'show_weight', 'show_body_type',
    'show_kids', 'show_pets', 'show_pronouns', 'show_orientation', 'show_ethnicity',
    'show_religion', 'show_political_view', 'show_languages', 'show_zodiac',
    'show_education', 'show_employment', 'show_school', 'show_company', 'show_job_title',
    'show_income', 'show_smoking', 'show_drinking', 'show_cannabis', 'show_drugs',
    'show_exercise', 'show_rel_structure', 'show_disclosures',
    'show_sexual_role', 'show_sexual_dynamics',
    'show_age', 'show_gender', 'show_relationship_status', 'show_interested_in',
    'show_age_range', 'show_looking_for', 'show_location', 'show_long_distance',
    'show_wants_more_kids', 'show_pets_wants', 'show_career_field',
];
